import type { AppProps } from 'next/app'
import { ChakraProvider } from '@chakra-ui/react'
import '../fcl/config'
import { AnalyticsProvider } from 'src/lib/analytics'
import { useEffect } from 'react'
import { welcomeConsole } from 'src/lib/welcome'
import theme from 'src/theme'


// this is because old builds had it being set to `light` and it was overriding all the dark settings...
if (typeof window !== 'undefined') {
  window.localStorage.removeItem('chakra-ui-color-mode')
}

function MyApp({ Component, pageProps }: AppProps) {
  useEffect(() => {
    welcomeConsole()
  }, [])
  return (
    <ChakraProvider theme={theme}>
      <AnalyticsProvider>
        <Component {...pageProps} />
      </AnalyticsProvider>
    </ChakraProvider>
  )
}

export default MyApp
